import './App.css';
import { Anchor, Card, Flex, FloatButton, Image, Skeleton, Space } from 'antd';
import useSWR from 'swr';
import { Typography } from 'antd';
import { useEffect } from 'react';

const { Title } = Typography;

const fetcher = async (url: string) => {
    const res = await fetch(url, {
        headers: new Headers({
            'Access-Control-Allow-Origin': '*',
        }),
    });
    const json = await res.json();
    if (!json.success) {
        const error = new Error((await json).message);
        throw error;
    }
    return json;
};

const EmotionCard = ({ category_name, category_id }: any) => {
    const { data, error, isLoading } = useSWR(
        `https://api.lynne.com.cn/emotion/images?category_id=${category_id}`,
        fetcher
    );
    useEffect(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }, []);
    if (error) return <div>居然加载失败了喵！</div>;
    if (isLoading) return <Skeleton active />;
    return (
        <>
            <Card
                title={category_name}
                bordered={false}
                style={{ width: '100%' }}>
                <Space wrap size={'large'}>
                    {data.data.map((pic: any, index: any) => {
                        return (
                            <Flex
                                key={pic.filename}
                                justify='center'
                                align='middle'
                                vertical>
                                <Image
                                    style={{
                                        maxHeight: 125,
                                        objectFit: 'contain',
                                    }}
                                    src={`https://nekoda.cn/usr/uploads/${pic.filename}`}
                                    placeholder={<Skeleton.Image active />}
                                    loading='lazy'
                                />
                                <div style={{ textAlign: 'center' }}>
                                    {pic.description}
                                </div>
                            </Flex>
                        );
                    })}
                </Space>
            </Card>
        </>
    );
};

const Emotion = () => {
    const { data, error, isLoading } = useSWR(
        'https://api.lynne.com.cn/emotion/categories',
        fetcher
    );

    if (error) return <div>failed to load</div>;
    if (isLoading) return <div>loading...</div>;
    const categories = [];
    const anchors = [
        {
            key: 'part0',
            href: '#part0',
            title: '全部',
        },
    ];
    for (let i = 0; i < data.data.length; i++) {
        categories.push({
            value: data.data[i].id,
            label: data.data[i].category_name,
        });
        anchors.push({
            key: `part${data.data[i].id}`,
            href: `#part${data.data[i].id}`,
            title: data.data[i].category_name,
        });
    }
    // 渲染数据
    return (
        <>
            <Flex align='center' justify='middle'>
                <Title level={2} style={{ margin: '15px 0', flex: 1 }}>
                    表情包合集
                </Title>
            </Flex>

            <Space
                direction='vertical'
                size={'middle'}
                style={{ width: '100%' }}>
                <Anchor
                    className='anchor'
                    direction='horizontal'
                    items={anchors}
                    style={{
                        padding: '2px 15px',
                        borderRadius: '8px',
                    }}
                />
                <div id='part0'>
                    <EmotionCard category_name='全部' category_id={0} />
                </div>
                {data.data.map((category: any, index: any) => {
                    return (
                        <div
                            id={`part${category.id}`}
                            key={category.category_name}>
                            <EmotionCard
                                category_name={category.category_name}
                                category_id={category.id}
                            />
                        </div>
                    );
                })}
            </Space>
            <FloatButton.BackTop />
        </>
    );
};

export default Emotion;
